import React, { useState } from 'react'
import moment from 'moment'

import RoleForm from './RoleForm'
import RoleTable from './RoleTable'
import Snackbars from '../../snackbars/SnackBars'
import Spinner from '../../commons/Spinner'
import SecurityAdministrationLayout from '../../commons/SecurityAdministrationLayout'

import { saveRole } from 'actions/roleActions'
import { useForm } from 'utils/customHooks/useForm'
import { putToApi } from 'actions'
import { ROLES_PATH } from '../../../constants'

const Role = () => {
   const [dataTable, setDataTable] = useState([])
   const [keyComponent, setKeyComponent] = useState(1)
   const [message, setMessage] = useState({
      open: false,
      text: '',
      type: '',
      fontColor: ''
   })
   const [openSpinner, setOpenSpinner] = useState(false)
   const [isPopoverOpen, setIsPopoverOpen] = useState(true)

   const [formBehavior, setFormBehavior] = useState({
      search: false,
      register: true,
      edit: false
   })

   const saveNewRole = dataForm => {
      setIsPopoverOpen(false)
      setOpenSpinner(true)
      setMessage(oldData => ({
         ...oldData,
         open: false
      }))
      saveRole(dataForm)
         .then(response => {
            if (response.status === 200 || response.status === 201) {
               setDataTable([response.data])
               setKeyComponent(keyComponent + 1)
               setMessage({
                  open: true,
                  text: 'El rol se guardó correctamente.',
                  type: 'info',
                  fontColor: '#fff'
               })
            } else {
               setMessage({
                  open: true,
                  text:
                     response.data?.message.length > 0
                        ? response.data.message
                        : 'Lo sentimos, hubo un problema al guardar el rol.',
                  type: 'error',
                  fontColor: '#fff'
               })
               setIsPopoverOpen(true)
            }
            setOpenSpinner(false)
         })
         .catch(err => {
            setMessage({
               open: true,
               text: 'Lo sentimos, hubo un problema al guardar el rol.',
               type: 'error',
               fontColor: '#fff'
            })
            setOpenSpinner(false)
            setIsPopoverOpen(true)
         })
   }

   const [formData, handleInputChange, setForm, reset] = useForm({
      name: '',
      description: '',
      status: 'A',
      initialDate: '',
      finalDate: '',
      domain: ''
   })

   const editRoleAction = async payload => {
      delete payload.initialDate
      payload.finalDate = moment(payload.finalDate).format('YYYY-MM-DD')

      setMessage(old => ({
         ...old,
         open: false
      }))
      try {
         const dateFinal = moment(payload.finalDate)
         if (!dateFinal.isValid()) {
            payload.finalDate = null
         }
         const editedRol = await putToApi(
            `${process.env.REACT_APP_ROLES_API}${ROLES_PATH}/${payload.id}`,
            payload
         )

         setDataTable([editedRol])
         setKeyComponent(keyComponent + 1)
         setMessage({
            open: true,
            text: 'El rol se editó correctamente.',
            type: 'info',
            fontColor: '#fff'
         })
         setIsPopoverOpen(false)
         setFormBehavior({
            search: true,
            register: false,
            edit: false
         })

         formData.id = ''
         formData.name = ''
         formData.description = ''
         formData.status = ''
         formData.initialDate = ''
         formData.finalDate = ''
         formData.domain = ''
      } catch (e) {
         setMessage({
            open: true,
            text:
               e?.message || 'Lo sentimos, hubo un problema al guardar el rol.',
            type: 'error',
            fontColor: '#fff'
         })
         setIsPopoverOpen(true)
      }
   }

   return (
      <React.Fragment>
         <Spinner open={openSpinner} />
         <SecurityAdministrationLayout
            form={
               <RoleForm
                  formData={formData}
                  handleInputChange={handleInputChange}
                  setForm={setForm}
                  reset={reset}
                  onData={saveNewRole}
                  formBehavior={formBehavior}
                  key={keyComponent}
                  editRoleAction={editRoleAction}
               />
            }
            table={
               <RoleTable
                  key={keyComponent}
                  dataTable={dataTable}
                  formData={formData}
                  setFormBehavior={setFormBehavior}
                  formBehavior={formBehavior}
                  setIsPopoverOpen={setIsPopoverOpen}
               />
            }
            title={
               formBehavior.edit
                  ? 'Editar Rol de Usuario'
                  : 'Registrar Rol de Usuario'
            }
            popoverProp={isPopoverOpen}
            setPopoverProp={value => setIsPopoverOpen(value)}
         />
         {message.open && (
            <Snackbars
               severity={message.type}
               fontColor={message.fontColor}
               message={message.text}
            />
         )}
      </React.Fragment>
   )
}

export default Role
